import React from 'react';

const MySQL = () => {
  return (
    <div className="content-page">
      <h1>MySQL Tutorial</h1>
      
      <div className="tutorial-section">
        <h2>What is MySQL?</h2>
        <p>MySQL is a widely used relational database management system (RDBMS) that runs as a server providing multi-user access to a number of databases. It is an open-source solution that is part of the LAMP stack (Linux, Apache, MySQL, PHP/Perl/Python).</p>
      </div>

      <div className="example">
        <h3>Example</h3>
        <div className="code-container">
          <pre>{`-- Create a database
CREATE DATABASE mydatabase;

-- Use the database
USE mydatabase;

-- Create a table
CREATE TABLE customers (
    id INT AUTO_INCREMENT PRIMARY KEY,
    name VARCHAR(100),
    email VARCHAR(100),
    created_at TIMESTAMP DEFAULT CURRENT_TIMESTAMP
);

-- Insert data
INSERT INTO customers (name, email) 
VALUES ('John Doe', 'john@example.com');

-- Query data
SELECT * FROM customers;

-- Update data
UPDATE customers 
SET email = 'john.doe@example.com' 
WHERE id = 1;

-- Delete data
DELETE FROM customers 
WHERE id = 1;`}</pre>
          <button className="try-it-btn">Try it Yourself »</button>
        </div>
      </div>

      <div className="tutorial-navigation">
        <button className="btn-prev">❮ Previous</button>
        <button className="btn-next">Next ❯</button>
      </div>
    </div>
  );
};

export default MySQL;
